import { useField } from 'formik';
import { NumericFormat } from 'react-number-format';
import React from 'react';

type NumberInputProps = {
  name: string;
  max: string;
  dataCy?: string;
  title?: string;
};

const NumberInput = ({ name, max, dataCy, title }: NumberInputProps) => {
  const [field, , helpers] = useField(name);

  const convertStringToNumber = (str: string) => {
    const withoutThousandSeparators = str.replace(/\s/g, '');
    const withDotAsDecimalSeparator = withoutThousandSeparators.replace(',', '.');
    return parseFloat(withDotAsDecimalSeparator);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    formatValue(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      formatValue(event.currentTarget.value);
    }
  };

  const formatValue = (value: string) => {
    let currentValue = value;
    if (currentValue) {
      let [integerPart, decimalPart] = currentValue.split(',');
      integerPart = integerPart.replace(/^0+/, '') || '0';
      if (!decimalPart) {
        currentValue = `${integerPart},00`;
      } else {
        decimalPart = decimalPart.padEnd(2, '0');
        currentValue = `${integerPart},${decimalPart}`;
      }
      helpers.setValue(currentValue);
    }
  };

  return (
    <NumericFormat
      {...field}
      thousandSeparator={' '}
      decimalSeparator={','}
      decimalScale={2}
      allowNegative={false}
      value={field.value}
      max={max}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{ width: '120px', textAlign: 'center' }}
      isAllowed={({ floatValue }) =>
        floatValue === undefined || floatValue <= convertStringToNumber(max)
      }
      data-cy={dataCy}
      title={title}
    />
  );
};

export default NumberInput;
